export default __webpack_public_path__ + "static/media/me3_SSO_Envelope.ca8b734c.svg";